import { Component, input } from '@angular/core';
import { BarInputs } from '@charts';
import { BarChartComponent } from "../bar-chart";

@Component({
  selector: 'ui-tsabt-voltage-chart',
  imports: [BarChartComponent],
  template: `
    <ui-bar-chart [barInputs]="barInputs()" />
  `
})

export class TsabtVoltageChartComponent {
  barInputs = input.required<BarInputs>();
}
